// removed by extract-text-webpack-plugin
module.exports = {"definition":"definition__definition___3fgXx","definition4box":"definition__definition4box___24GEt"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/skin/styles/list/definition.css
// module id = 1237
// module chunks = 0